import { Label, Textarea } from "@xola/ui-kit";
import clsx from "clsx";
import React from "react";
import { useFeedbackStore } from "../../stores/feedbackStore";

interface TextInputProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    onSetValue: (value: string) => void;
    error?: string;
}

const TextInput = ({ title, className, onSetValue, error, ...rest }: TextInputProps) => {
    const handleChange = (e: any) => {
        const v = e.target.value;
        if (onSetValue) {
            onSetValue(v);
        }
    };

    return (
        <div className="mt-8">
            <Label className="whitespace-nowrap" isError={Boolean(error)}>
                {error ? error : title}
            </Label>
            <Textarea
                rows={7}
                className={clsx("leading-5", className)}
                defaultValue=""
                isError={Boolean(error)}
                onChange={handleChange}
                {...rest}
            />
        </div>
    );
};

export const ProblemInput = ({ error }: { error?: string }) => {
    const setProblem = useFeedbackStore((state) => state.setProblem);
    return (
        <TextInput
            title="Problem Description"
            placeholder="Describe limitation you are experiencing and the result of that limitation (e.g. what do you have to do to work around it)"
            error={error}
            onSetValue={(value: string) => setProblem(value)}
        />
    );
};

export const SolutionInput = () => {
    const setSolution = useFeedbackStore((state) => state.setSolution);
    return (
        <TextInput
            title="Proposed Solution"
            placeholder={`Describe the the end result of what a solution would accomplish.\n\nFeel free to propose a solution`}
            onSetValue={(value: string) => setSolution(value ? value : undefined)}
        />
    );
};
